import gql from 'graphql-tag'

import { LeadFieldsFragment } from 'main/gql/lead'
import { SchoolFieldsFragment } from 'main/gql/school'
import { UserFieldsFragment, UserWithFamilyFieldsFragment } from 'main/gql/user'

export const BOOKMARK_AUTH_MODAL_QUERY = gql`
  query BookmarkAuthModal($schoolId: Int!) {
    school(id: $schoolId) {
      ...SchoolFields
    }
    user {
      ...UserFields
      ...UserWithFamilyFields
    }
  }

  ${LeadFieldsFragment}
  ${SchoolFieldsFragment}
  ${UserFieldsFragment}
  ${UserWithFamilyFieldsFragment}
`
